module.exports = "./img/3f8554bf652ac0ebe7bace1af1b44193.jpg";